import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import {Observable, of} from "rxjs";
import {UserService} from "../common/user.service";
import {IShopUser} from "../session/customer-models";
import {AuthUtil} from "../auth/auth-util";
import {UsanaObject} from "../usana-object";
import {LoggerService} from "../common/logger.service";
import {Constants} from "../constants";
import {map, switchMap, take} from "rxjs/operators";
import {LoginModalService} from "../login/login-modal.service";

@Injectable({
    providedIn: 'root',
})
export class UserRolesGuard extends UsanaObject  {

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private loginModalService: LoginModalService,
        private router: Router
    ) {
        super(loggerService);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {
        return this.checkRoles(route, state);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {
        return this.checkRoles(route, state);
    }

    checkRoles(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {
        if (!!route.data && !!route.data.roles) {
            if(state.url.endsWith(Constants.RELOAD_STATE)) {
                return of(true);
            }
            return this.userService.getShopUser().pipe(switchMap((user: IShopUser) => {
                //not authorized for state, don't continue route and redirect in one of below options
                if (!AuthUtil.isStateAuthorized(route.data, user.authorities)) {
                    this.log.debug("Unauthorized state attempted => ", state.url);
                    if (AuthUtil.isRetail(user)) {
                        if (AuthUtil.isCbec(user)) {
                            return of(this.router.createUrlTree([Constants.CBEC_STATE, Constants.CBEC_LANDING_STATE]));
                        } else {
                            return this.loginModalService.openLogin().pipe(take(1), map(() => false));
                        }
                    } else if (AuthUtil.isNfrMhpOnly(user)) {
                        return of(this.router.createUrlTree([Constants.MHP_STATE, Constants.MHP_WHY_STATE]));
                    //authenticated cbec
                    } else if (AuthUtil.isCbec(user)) {
                        return of(this.router.createUrlTree([Constants.CATALOG_STATE, -1]));
                    } else {
                        return of(this.router.createUrlTree([Constants.LANDING_STATE]));
                    }
                } else {
                    //user is authorized, continue routing
                    return of(true);
                }
            }));
        } else {
            this.log.debug("State role not defined. Add role for => ", state.url);
            return true;
        }
    }
}
